<template>
	<div class="main-content chat-page">
        <div id="msgBoard">	
            <message 		
                v-for="perMsg in chatHistory"
                :key="perMsg.uuid"
                :payload='perMsg'
                @jump-to-profile="jumptoprofile"
                @query-name='queryName'
            />
		</div>
        <div id="bottom"></div>
        <sendBox @send-message="sendMsg"/>

        <div id="ChatPage-modal-card-shadow" :style="{display:status}" class="modal" @click="closeCard">
            <div class="modal-card">
                <quickProfile :profile='this.groupBrief' :display='true' />
            </div>
        </div>

	</div>
</template>

<script>
// @ is an alias to /src
import sendBox from "@/components/sendBox.vue"
import message from "@/components/message.vue"
import quickProfile from "@/components/quickProfile.vue"
const uuidv4 = require('uuid/v4');

export default {
    name: 'ChatPage',
	components: {
        sendBox,
        message,
        quickProfile
    },
    data: function (){
		return {
            chatHistory:[],
            groupIndex:Number,
            firstScroll:true,
            groupData:{},
            userUids:new Set(),
            quantity:0
		}
    },
	updated: function () {
            // console.log(document.body.scrollHeight+" "+this.firstScroll+" "+this.chatHistory.length);
            if(this.chatHistory.length!==0 && this.firstScroll){
                this.firstScroll=false;
                // console.log('init scroll');
                document.querySelector("#bottom").scrollIntoView();
            }
	},
    watch: {
        '$store.state.chats': {
            handler: function(newer, older) {
                // alert('new');
                this.chatHistory=newer[this.groupIndex].history; // get and update data chatHistory
                if(newer[this.groupIndex].p2p === 1){
                    let usernames=newer[this.groupIndex].title.split(',');
                    this.$store.state.nowTitle=(usernames[0] === this.$store.state.userName)?usernames[1]:usernames[0];
                }else{
                    this.$store.state.nowTitle=newer[this.groupIndex].title;
                }
                // this.scrollToBottom();

                this.groupData=newer[this.groupIndex]; // get and update data chatHistory
            },
            deep: true
        }
    },
    methods:{
        sendMsg(msg){
            let uuid=uuidv4();
            this.$store.commit('updateChat',{userName:msg.userName,message:msg.message,date:msg.date,type:'userMsg',errorMsg:(msg.status==='loggedin') ? false:true,cid:parseInt(this.$route.params.cid),groupIndex:this.groupIndex,uuid:uuid,success:false});
            this.$store.commit('updateLastestMessage',{cid:this.$route.params.cid,date:msg.date,msg:msg.userName+": "+msg.message,localMsg:true});
            if(msg.status=='loggedin'){
                // this.$emit('send-message',{message:msg.message,userName:msg.userName,date:msg.date,cid:this.$route.params.cid});
                this.$socket.emit('message', {message:msg.message,userName:msg.userName,date:msg.date,cid:parseInt(this.$route.params.cid),uuid:uuid});
            }
            this.scrollToBottom();
        },
        jumptoprofile(payload){
            this.$emit('jump-to-profile',payload.uid);
        },
        scrollToBottom(){
            this.$nextTick(function () {
                // console.log(document.querySelector("#msgBoard > div:last-child"));
                // console.log(document.body.scrollHeight);
                // window.scrollTo(0,document.body.scrollHeight);
                document.querySelector("#bottom").scrollIntoView();
            });
            // window.scrollTo(0,document.body.scrollHeight);
            // let container=document.querySelector("#msgBoard");
            // document.querySelector("#msgBoard > div:last-child").scrollIntoView();
            // container.scrollTop=container.scrollHeight;
        },
        pullHistory(){
            console.log('pulling');
            this.$socket.emit('loadHistory',{cid:parseInt(this.$route.params.cid),lastUpdateDatetime:(this.groupIndex !==  null &&  this.$store.state.chats[this.groupIndex].history.length !== 0)?this.$store.state.chats[this.groupIndex].history[this.$store.state.chats[this.groupIndex].history.length-1].date:'all'}); // this.$store.state.chats[this.groupIndex].history[this.$store.state.chats[this.groupIndex].history.length-1].date}
        },
        closeCard:function(){
            let modal = document.getElementById('ChatPage-modal-card-shadow');
            if (event.target == modal) {
                this.$store.state.chatPageModalOpen=false;
            }
        },
        queryName:function(payload){
            if(this.quantity+1 === this.chatHistory.length){
                // console.log('request ref!');
                let users = [...this.userUids];
                this.axios
                    .post(this.$store.state.baseUrl+'/users',{
                        users:users
                    })
                    .then(res=>{
                        if(res.data.error === false){
                            res.data.users.map(user =>{
                                this.$store.state.contactRef[user.uid]=user.name;
                                this.$store.state.contactRefTrace++;
                            })
                        }
                    })
                    .catch(err=> {
                        console.log('error');
                        console.log(err);
                    });
            }else{
                // console.log(this.quantity+'-'+this.chatHistory.length);
                if(payload.uid !== null){
                    this.userUids.add(payload.uid);
                }
                this.quantity++;
            }
        }
    },
    mounted(){
        if(this.$store.state.userStatus !== 'loggedin'){
            this.$router.push({path:`/Login`,replace:true});
			// this.$router.go(1);
        }
        // Retrieve local history if exists, and send last update date to server so that later messages can be accessed 
        let chatFinder=0;
        while(chatFinder<this.$store.state.chats.length){
            if(this.$store.state.chats[chatFinder].cid==this.$route.params.cid){
                this.groupIndex=chatFinder;
                this.chatHistory=this.$store.state.chats[chatFinder].history;

                this.groupData=this.$store.state.chats[chatFinder];

                this.$store.state.chats[chatFinder].messageCount=0;
                if(this.$store.state.chats[chatFinder].p2p === 1){
                    let usernames=this.$store.state.chats[chatFinder].title.split(',');
                    this.$store.state.nowTitle=(usernames[0] === this.$store.state.userName)?usernames[1]:usernames[0];
                }else{
                    this.$store.state.nowTitle=this.$store.state.chats[chatFinder].title;
                }
                this.scrollToBottom();
                break;
            }
            chatFinder++;
        }
        if(chatFinder===this.$store.state.chats.length)chatFinder=null;
        // Send an anchor date retrieved from chat.history(NOT FROM ROOT lastUpdateDatetime)
        let lastReceiveTime='all',historyArray=this.$store.state.chats[chatFinder].history;
        if(chatFinder !==  null &&  this.$store.state.chats[chatFinder].history.length !== 0){
            let i=1;
            while(historyArray[historyArray.length-i].hasOwnProperty('success') && !historyArray[historyArray.length-i].success){
                i++;
            }
            lastReceiveTime=historyArray[historyArray.length-i].date;
        }
        this.$socket.emit('loadHistory',{cid:parseInt(this.$route.params.cid),lastUpdateDatetime:lastReceiveTime});
    },
    computed:{
        status(){
            if(this.$store.state.chatPageModalOpen===false){
                return 'none'
            }else if(this.$store.state.chatPageModalOpen===true){
                return 'block'
            }
        },
        groupBrief(){
            let obj={};
            
            let url=this.$store.state.baseUrl+'/groupPic/'+this.groupData.cid;
            if(this.groupData.p2p === 1){
                let targetUid=(this.groupData.peer1 === this.$store.state.UID)?this.groupData.peer2:this.groupData.peer1;
                url=this.$store.state.baseUrl+'/userPic/'+targetUid;

                obj.uid=targetUid;
                obj.url=url;
                obj.title=this.$store.state.nowTitle;
                obj.des='a user';
                obj.category='user';
            }else{
                obj.cid=this.groupData.cid;
                obj.url=url;
                obj.title=this.$store.state.nowTitle;
                obj.des=this.groupData.des;
                obj.category='group';
            }

            return obj
        }
    }
}
</script>

<style>  
    .chat-page{
        background-attachment: fixed;
        padding-bottom: 48px;
    }

    #msgBoard {
        display: flex;
        flex-direction: column;
        width: 100vw;
        margin-bottom: 12px;
        overflow: hidden;
    }
</style>

